import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface SessionTimeoutData {
  countdown: number;
}

@Component({
  selector: 'app-session-timeout-warning',
  templateUrl: './session-timeout-warning.component.html',
  styleUrls: ['./session-timeout-warning.component.scss'],
  standalone: false
})
export class SessionTimeoutWarningComponent {
  countdown: number;

  constructor(
    public dialogRef: MatDialogRef<SessionTimeoutWarningComponent>,
    @Inject(MAT_DIALOG_DATA) public data: SessionTimeoutData
  ) {
    this.countdown = data.countdown;
  }

  /**
   * User clicked "Continue Session" button
   */
  continueSession(): void {
    this.dialogRef.close('continue');
  }

  /**
   * User clicked "Logout" button
   */
  logout(): void {
    this.dialogRef.close('logout');
  }

  /**
   * Format countdown in MM:SS format
   */
  getFormattedCountdown(): string {
    const minutes = Math.floor(this.countdown / 60);
    const seconds = this.countdown % 60;
    return `${minutes}:${seconds.toString().padStart(2, '0')}`;
  }
}
